import {DetailGrid, Utility, wdiCore} from '@/components/GridWidget';
import {WdiCardTitle, WdiModalAppResult, WdiModalProps} from '@/components/WdiControls';
import {WdiPanel} from '@/components/WdiControls/WdiPanel';
import {ImportModalApp} from '@/components/WdiControls/WdiImport';
import {Enum} from '@/enums/system';
import React, {ReactNode, useEffect, useState} from 'react';
import {GridApi} from '@/services/gridapi';
import {ResponseStatus} from '@/utils/request';
import {NsGrid} from '@/components/GridWidget/GridDefProps';
import {Button, Dropdown, Menu, message, Space} from 'antd';
import {initFieldDisplayFormater, TableColumnRanderFormats} from '@/components/WdiBus/TableColumnRanderFormats';
import DataStore from '@/components/GridWidget/DataStore';
import {ToExcelProps} from '@/components/WdiControls/WdiExcel';
import {Product} from '@/services/mdm/product';
import {ECMKT} from '@/services/mdm/ecmkt';
import FormSaMktDetailEditApp from "@/pages/mkt/sa/MktApply/components/DetailEdit";
import FormSaMktDetailCompareModalApp from "@/pages/mkt/sa/components/FormSaMktDetailCompare";
import {Company} from "@/services/mdm/company";

const ModalTypeEnums = {
  None: 0,
  Insert: 1,
  Import: 2,
};

export type DetailForApplyProps = {
  form?: API.Form,
  dataSource: any[],
  onChange?: (dataSource: any) => void;
};

const FormSaMktDetailsForApplyPanel: React.FC<DetailForApplyProps> = (props) => {

  const [isLoaded, setIsLoaded] = useState(false);
  const [gridSettings, setGridSettings] = useState<any>({});
  const [importExcels, setImportExcels] = useState<ToExcelProps[]>([]);
  const [modalProps, setModalProps] = useState<WdiModalProps>({visible: false});
  const {dataSource, onChange} = props;

  const onImportSave = (uploadResult: any) => {
    if (uploadResult.code == ResponseStatus.SUCCESS) {
      const newDataSource = [...dataSource];
      const result = uploadResult?.data?.data;

      if (result && result.length > 0) {
        if (uploadResult?.data?.exProperty) {
          //是否清空
          onChange?.(DataStore.init(result));
        } else {
          onChange?.(DataStore.addMulti(newDataSource, result));
        }
      }
    }
    setModalProps({visible: false, title: '', type: ModalTypeEnums.None, id: null});
  };

  const onModalClose = () => {
    setModalProps({visible: false, title: '', type: ModalTypeEnums.None, id: null});
  };

  const onEditSave = (result?: WdiModalAppResult) => {
    if (result && result.code === ResponseStatus.SUCCESS) {
      const row = result?.data;
      if (result?.data.rowIndex > -1) {
        const record = modalProps.data.row;
        const newItem = {...row};
        newItem.uid = record.uid;
        onChange?.(DataStore.edit(dataSource, newItem));
      } else {
        const newItem = {...row};
        onChange?.(DataStore.add(dataSource, newItem));
      }
    }
    setModalProps({visible: false, title: '', type: ModalTypeEnums.None, id: null});
  };


  useEffect(() => {
    GridApi.searchConfig({id: 'FormSaMktDetailForApply', allowModifyColumns: false}).then((response) => {
      const settings: any = Object.assign({}, response.data, {
        actionsAlign: NsGrid.ActionsAlign.Left,
        showAggr: true,
      });

      initFieldDisplayFormater(settings.formSchema.allFields);

      settings.formSchema.allFields.rowNumber.width = 50;
      settings.formSchema.allFields.productId.width = 200;
      settings.formSchema.allFields.ecMktId.width = 180;
      //settings.formSchema.allFields.contentDesc.width = 180;
      settings.formSchema.allFields.paymentMethodId.width = 180;
      settings.formSchema.allFields.amount.width = 120;
      settings.formSchema.allFields.remark.width = 180;
      settings.formSchema.allFields.amount.aggr = TableColumnRanderFormats.sumAggr('amount', 2);


      setActionCallbacks(settings);
      setGridSettings(settings);
      setIsLoaded(true);
    });
  }, []);


  useEffect(() => {
    const companySheet = {
      dataLoading: async () => {
        return await Company.search({
          isActive: true
        });
      },
      data: null,
      names: [
        {name: 'companyCode', displayName: '公司编号'},
        {name: 'companyName', displayName: '公司名称'},
        {name: 'salesOrgCode', displayName: '所属ORG编号'},
      ],
      sheetName: '公司列表',
    };
    const productSheet = {
      dataLoading: async () => {
        return await Product.queryForCompanySheet({
          withPermissions: true,
          isActive: true,
          productLevel: Enum.ProductLevel.PRODUCT3
        });
      },
      data: null,
      names: [
        {name: 'productCode3', displayName: '销售小类编号'},
        {name: 'productName3', displayName: '销售小类名称'},
        {name: 'productCode2', displayName: '销售大类编号'},
        {name: 'productName2', displayName: '销售大类名称'},
        {name: 'productCode1', displayName: '品牌编号'},
        {name: 'productName1', displayName: '品牌名称'},
        {name: 'companyCodes', displayName: '公司编号'},
      ],
      sheetName: '产品别列表',
    };
    const ecMktSheet = {
      dataLoading: async (params: any) => {
        return await ECMKT.GetEcMktStructureList(
          Object.assign(
            {
              ecLevel: Enum.ECLevel.EC3,
              isActive: true,
            },
            params,
          ),
        );
      },
      data: null,
      names: [
        {name: 'ecMktName1', displayName: '费用大类名称'},
        {name: 'ecMktName2', displayName: '费用小类名称'},
        {name: 'ecMktName3', displayName: '费用项名称'},
        {name: 'remark', displayName: '费用项描述'},
      ],
      sheetName: '费用类别',
    };
    setImportExcels([
      {
        name: '全部下载',
        sheetProps: [companySheet, productSheet, ecMktSheet],
      },
      {
        name: '公司列表',
        sheetProps: [companySheet]
      },
      {
        name: '产品别列表',
        sheetProps: [productSheet],
      }, {
        name: '费用类别列表',
        sheetProps: [ecMktSheet],
      },
    ]);
  }, []);

  const setActionCallbacks = (settings: any) => {
    Utility.setActionCallback(settings.formSchema.actions, 'Update',
      async (grid: any, action: any, record: any) => {
        const context = grid.getContext();
        setModalProps({
          visible: true,
          title: '编辑费用明细',
          type: ModalTypeEnums.Insert,
          id: record.formSaMktDetailId,
          data: {
            row: record,
            rows: context.dataSource,
            rowIndex: DataStore.getRowIndex(context.dataSource, record.uid),
          },
        });
      },
    );

    Utility.setActionCallback(settings.formSchema.actions, 'Copy',
      async (grid: any, action: any, record: any) => {
        const context = grid.getContext();
        setModalProps({
          visible: true,
          title: '新建费用明细',
          type: ModalTypeEnums.Insert,
          id: null,
          data: {
            row: record,
            rows: context.dataSource,
            rowIndex: -1,
          },
        });
      },
    );

    Utility.setActionCallback(settings.formSchema.actions, 'SystemDelete',
      async (grid: any, action: any, record: any) => {
        if (window.confirm('确定要删除此条信息吗？')) {
          const context = grid.getContext();
          onChange?.(DataStore.del(context.dataSource, record.uid));
          message.success('删除成功');
        }
      },
    );
  };

  const pageGridSettings = Object.assign({
    antdProps: {
      dataSource,
      pagination: {
        defaultPageSize: 10,
        showSizeChanger: true,
      },
    },
  }, gridSettings);

  return (
    <>
      {
        isLoaded && modalProps.visible && (modalProps.type === ModalTypeEnums.Insert)
        && <FormSaMktDetailEditApp {...modalProps} onClose={onModalClose} onSave={onEditSave}/>
      }
      {
        isLoaded && modalProps.visible && modalProps.type === ModalTypeEnums.Import
        && <ImportModalApp
          title={modalProps.title}
          visible={modalProps.visible}
          settingsUrl='/expenseapi/saMktButtons/getImportSettings'
          uploadingUrl='/expenseapi/saMktButtons/importUploading'
          onClose={onModalClose}
          onSave={onImportSave}
          clientParameters={{
            formSaMktDetails: JSON.stringify(dataSource),
          }}
          importExcels={importExcels}
        />
      }
      <WdiPanel
        title={<WdiCardTitle iconType={Enum.IconType.DETAIL_INFO} title='费用明细信息'/>}
        collapsed={false}
        extra={
          <Space>
            <Dropdown.Button
              buttonsRender={(buttons: ReactNode[]) => {
                return [buttons[0], <Button type={"primary"} style={{width: 50, fontSize: 12}}>更多</Button>]
              }}
              type='primary'
              onClick={() => {
                setModalProps({
                  visible: true,
                  title: '新建费用明细',
                  type: ModalTypeEnums.Insert,
                  id: null,
                  data: {
                    rows: dataSource,
                    rowIndex: -1,
                  },
                });
              }}
              overlay={
                <Menu items={
                  [{
                    key: 'import',
                    label: '导入',
                    onClick: () => {
                      setModalProps({title: '费用明细导入', visible: true, type: ModalTypeEnums.Import});
                    },
                  }]}
                />
              }
              style={{float: 'right'}}>
              新建
            </Dropdown.Button>
          </Space>
        }
      >
        {
          isLoaded && <DetailGrid {...pageGridSettings} autoColumn={['rowNumber']}/>
        }

      </WdiPanel>
    </>
  );
};
export default FormSaMktDetailsForApplyPanel;

export const FormSaMktDetailsForApprovalPanel: React.FC<DetailForApplyProps> = (props) => {

  const [isLoaded, setIsLoaded] = useState(false);
  const [gridSettings, setGridSettings] = useState<any>({});
  const [detailCompareProps, setDetailCompareProps] = useState<WdiModalProps>({visible: false});
  const {dataSource, form} = props;


  useEffect(() => {
    GridApi.searchConfig({id: 'FormSaMktDetailForApproval', allowModifyColumns: true}).then((response) => {
      const settings: any = Object.assign({}, response.data, {
        actionsAlign: NsGrid.ActionsAlign.None,
        showAggr: true,
        showExpandedRow: true,
      });

      initFieldDisplayFormater(settings.formSchema.allFields);

      settings.formSchema.allFields.rowNumber.width = 50;
      settings.formSchema.allFields.productId.width = 200;
      settings.formSchema.allFields.ecMktId.width = 180;
      //settings.formSchema.allFields.contentDesc.width = 180;
      settings.formSchema.allFields.paymentMethodId.width = 180;
      settings.formSchema.allFields.amount.width = 120;
      settings.formSchema.allFields.remark.width = 180;
      settings.formSchema.allFields.amount.aggr = TableColumnRanderFormats.sumAggr('amount', 2);

      setGridSettings(settings);
      setIsLoaded(true);
    });
  }, []);

  const maxAllowedFields = ['rowNumber', 'productId', 'ecMktId', 'ccCode', 'paymentMethodId', 'amount', 'remark', 'formSaMktDetailId'];

  const pageGridSettings = Object.assign({
    antdProps: {
      dataSource,
      initRowFieldConfigs: (record: any) => {
        return maxAllowedFields;
      },
      pagination: {
        defaultPageSize: 10,
        showSizeChanger: true,
      },
    },
  }, gridSettings);

  return (
    <>
      <WdiPanel
        title={<WdiCardTitle iconType={Enum.IconType.DETAIL_INFO} title='费用明细信息'/>}
        collapsed={false}
        extra={
          <Space>
            <Button
              onClick={(e) => {
                setDetailCompareProps({title: '费用明细变更对比', data: {form: form}, visible: true});
              }}
              hidden={wdiCore.Object.IsNullOrUndefined(form?.relatedFormId)}
              type='primary'>
              变更对比
            </Button>
          </Space>
        }
      >
        {
          isLoaded && detailCompareProps.visible &&
          <FormSaMktDetailCompareModalApp {...detailCompareProps}
                                          onClose={() => setDetailCompareProps({visible: false})}/>
        }
        {
          isLoaded && <DetailGrid {...pageGridSettings} autoColumn={['rowNumber']}/>
        }

      </WdiPanel>
    </>
  );
};


